import React from 'react';

import {
  ICanvasOverlay,
  ICanvasOverlayCallback,
} from '../../types/canvasOverlay';
import { CanvasOverlay } from './canvasOverlay';

interface ICanvasOverlayContainerProps {
  registerForUpdates: (cb: ICanvasOverlayCallback) => void;
}

export const CanvasOverlayContainer: React.FC<ICanvasOverlayContainerProps> = (
  props: ICanvasOverlayContainerProps,
) => {
  const { registerForUpdates } = props;
  const [overlays, setOverlays] = React.useState<ICanvasOverlay[]>([]);
  React.useEffect(() => {
    registerForUpdates((_overlays: ICanvasOverlay[]) => {
      setOverlays(_overlays);
    });
  }, [registerForUpdates]);

  return (
    <div data-aid="canvas-overlay-container" style={{ pointerEvents: 'none' }}>
      {overlays.map(({ appDefinitionId, url, visible }) => (
        <CanvasOverlay
          key={`${appDefinitionId}-overlay`}
          appDefinitionId={appDefinitionId}
          visible={visible}
          url={url}
        />
      ))}
    </div>
  );
};

export const getCanvasOverlayContainer = (
  register: (cb: ICanvasOverlayCallback) => void,
) => <CanvasOverlayContainer registerForUpdates={register} />;
